module.exports = __webpack_public_path__ + "media/SOC/edit-277ff27d.svg";